import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ModelSelectionModal = ({ show, onHide, heading, modelsList, agentsList }) => {
  return (
    <Modal show={show} onHide={onHide} centered size="lg" dialogClassName="modal-dialog-themed">
      <Modal.Header closeButton className="modal-header-themed">
        <Modal.Title className="modal-title-themed">{heading}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body-themed">
        {modelsList && modelsList.length > 0 && (
          <>
            <h4 style={{ marginBottom: '15px', color: '#1a1a1a', fontWeight: '500' }}>Available Models:</h4>
            <ul style={{ listStyle: 'none', padding: 0, marginBottom: '30px' }}>
              {modelsList.map((model, index) => (
                <li
                  key={index}
                  className="modal-list-item-hover"
                  style={{ marginBottom: '10px', fontSize: '16px', color: '#333333', lineHeight: '1.5', fontWeight: '300', cursor: 'pointer' }}
                  onClick={() => window.open(model.link, '_blank')}
                  onMouseEnter={(e) => { e.currentTarget.style.color = '#1a1a1a'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = '#333333'; }}
                >
                  <strong>{model.name}</strong>
                  {model.features && model.features.map((feature, featureIndex) => (
                    <span key={featureIndex} className="modal-pill">{feature}</span>
                  ))}: {model.description}
                </li>
              ))}
            </ul>
          </>
        )}

        {agentsList && agentsList.length > 0 && (
          <>
            <h4 style={{ marginBottom: '15px', color: '#1a1a1a', fontWeight: '500' }}>Open Source Agents:</h4>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {agentsList.map((agent, index) => (
                <li
                  key={index}
                  className="modal-list-item-hover"
                  style={{ marginBottom: '10px', fontSize: '16px', color: '#333333', lineHeight: '1.5', fontWeight: '300', cursor: 'pointer' }}
                  onClick={() => window.open(agent.link, '_blank')}
                  onMouseEnter={(e) => { e.currentTarget.style.color = '#1a1a1a'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = '#333333'; }}
                >
                  <strong>{agent.name}</strong>
                  {agent.features && agent.features.map((feature, featureIndex) => (
                    <span key={featureIndex} className="modal-pill">{feature}</span>
                  ))}: {agent.description}
                </li>
              ))}
            </ul>
          </>
        )}
      </Modal.Body>
      <Modal.Footer className="modal-footer-themed">
        <Button variant="secondary" onClick={onHide} style={{ backgroundColor: '#1a1a1a', border: 'none', color: '#f6f1e7', borderRadius: '30px', padding: '10px 25px', fontWeight: '500' }}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModelSelectionModal;
